import React from "react";
import { graphql } from "gatsby";
import Log from "../Log/Log";

import "./LogSection.scss";

const LogSection = props => {
  const { logs } = props
  const logsClean = logs.filter(log => log.title !== "DO-NOT-DELETE")

  return (
    <div className="log-section">
      {logsClean.map(log => (
        <Log
          title={log.title}
          description={log.description}
          poster={log.poster}
          video={log.video}
          videoMobile={log.videoMobile}
          key={log.title}
        />
      ))}
    </div>
  )
}

export default LogSection

export const query = graphql`
  fragment LogCardSectionFragment on Query {
    logSection: allMarkdownRemark {
      nodes {
        frontmatter {
          logs {
            poster {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_noBase64
                }
              }
            }
            description
            title
            video {
              publicURL
            }
            videoMobile {
              publicURL
            }
          }
        }
      }
    }
  }
`
